import { render, staticRenderFns } from "./ResultsBox.vue?vue&type=template&id=34de756a&scoped=true&"
import script from "./ResultsBox.vue?vue&type=script&lang=js&"
export * from "./ResultsBox.vue?vue&type=script&lang=js&"
import style0 from "./ResultsBox.vue?vue&type=style&index=0&id=34de756a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34de756a",
  null
  
)

export default component.exports